import React, { useState } from 'react'
import { IImageSliderProps } from './image-slider-props.interface'
import { Swiper, SwiperSlide } from 'swiper/react'
import './image-slider.scss'
import { IonIcon } from '@ionic/react'
import button_freccia_dx from 'theme/images/button_freccia_dx.svg'
import button_freccia_sx from 'theme/images/button_freccia_sx.svg'
import { Keyboard } from 'swiper'
import { Swiper as SwiperClass } from 'swiper/types'
import { BaseButton, ImageSliderModal } from 'components'
import { icon_image } from 'icons'
import { useTranslation } from 'react-i18next'

const ImageSlider: React.FC<IImageSliderProps> = ({ items, showAll, setActiveIndex, innerNavigation = true }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const [swiper, setSwiper] = useState<SwiperClass>()

  const { t } = useTranslation()

  const navComponent = swiper && (
    <div className="edisu-slider-navigation ion-hide-sm-down">
      <IonIcon
        src={button_freccia_sx}
        className="circle-arrow-btn"
        onClick={() => {
          swiper.slidePrev()
          !!setActiveIndex && setActiveIndex(swiper.activeIndex + 1)
        }}
      />
      <IonIcon
        src={button_freccia_dx}
        className="circle-arrow-btn"
        onClick={() => {
          swiper.slideNext()
          !!setActiveIndex && setActiveIndex(swiper.activeIndex + 1)
        }}
      />
    </div>
  )

  return (
    <div className="edisu-image-slider">
      <Swiper
        onSlideChangeTransitionEnd={() => !!setActiveIndex && setActiveIndex(swiper!.activeIndex + 1)}
        onSwiper={(swiper) => setSwiper(swiper)}
        keyboard
        modules={[Keyboard]}
        slidesPerView={1}
        slidesPerGroup={1}
      >
        {items.map((item, idx) => (
          <SwiperSlide key={idx}>
            <img src={item.image} />
          </SwiperSlide>
        ))}
        {innerNavigation && navComponent}

        {showAll && (
          <div className="show-all">
            <BaseButton icon={icon_image} label={t('show_all_images')} onClickFunction={() => setIsModalOpen(true)} />
          </div>
        )}
      </Swiper>
      {!innerNavigation && navComponent}

      <ImageSliderModal items={items} isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
    </div>
  )
}

export default ImageSlider
